define('views/modules/goal/list/goal-list-item',[
    // Libs
    'underscore', 'backbone', 'mustache', 'moment', 'bootbox', 'utils',
    // services
    'services/i18n',
    'services/toastr-service',
    'services/events/calendar-events',
    // models & collections
    'collections/calendar/items',
    'models/calendar/personal-data/personal-data-type',
    // views
    'views/parts/menu/menu-context',
    'views/parts/chart/double-doughnut-chart',
    'views/modules/calendar/calendar/calendar-component/item/calendar-item-list',
    // templates
    'text!templates/modules/goal/list/goal-list-item.html'
], function(
    // Libs
    _, Backbone, Mustache, moment, Bootbox, U,
    // services
    i18n,
    ToastrService,
    CalendarEvents,
    // models & collections
    CCalendarItems,
    MPersonalDataType,
    // views
    VMenuContext,
    VDoubleDoughnutChart,
    VCalendarItemList,
    // templates
    TGoalListItem
) {

    var VGoalListItem = Backbone.Epoxy.View.extend({
        template: TGoalListItem,

        events: {
            "click .options-toggle": "showMenuOptions",
        },

        regions: {
            menu: ".menu-options",
            chart: ".chart",
            items: ".calendar-items",
            noItems: ".no-calendar-items"
        },

        initialize: function(opt) {
            opt = this.options = _.extend({}, opt);

            this.collection = opt.calendarDays;
            var model = this.model,
                items = this.items = new CCalendarItems(null, {
                    comparator: function(a, b) {
                        return -a.get('date').localeCompare(b.get('date'));
                    }
                }),
                url = this.url = _.clone(opt.url);

            _.extend(this, {
                group: opt.group,
                profile: opt.profile,
                role: opt.role
            });

            this.view = {
                chart: new VDoubleDoughnutChart({
                    model: model,
                    goalClass: model.getProgressColor(),
                    title: false,
                }),
                items: new VCalendarItemList({
                    collection: items,
                    url: Mustache.render(url.root + 'calendar/', {
                        groupId: this.group.id,
                        userId: this.profile.id
                    }),
                    role: opt.role
                })
            };

            this.listenTo(model, { 'remove': this.remove })
                .listenTo(this.collection, { 'sync': this.onCalendarDaysSync })
                .listenTo(items, {
                    'destroy': this.onCalendarItemDestroy,
                    'add': this.onCalendarItemAdd
                });
        },

        initListener: function() {
            this.stopListeningTo(CalendarEvents);
            this.listenTo(CalendarEvents, {
                'item:update': this.onItemUpdate,
            });
            this.listenTo(CalendarEvents, {
                'goalNewItemToggle:done': this.onCalendarItemUpdate,
               });
            // this.listenTo(CalendarEvents, {
            //     'item:update': this.view.chart.render(),
            // });
        },

        render: function() {
            this.initListener();
            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext(this.options)));

            this.generateZones();
            var view = this.view,
                zone = this.zone;

            if (view.menu) {
                this.assign(view.menu, zone.$menu);
            }

            this.assign(view.chart, zone.$chart)
                .assign(view.items, zone.$items);

            this.filterItems();

            this.applyBindings();

            return this;
        },

        showMenuOptions: function(e) {
            e.preventDefault();
            var view = this.view.menu;
            if (!view) {
                this.view.menu = view = new VMenuContext({
                    context: this,
                    onClick: this.onActionClick,
                    collection: new Backbone.Collection([
                        { caption: "Edit", icon: "sl-icon-pencil", callback: this.onEditAction },
                        { caption: "Delete", icon: "sl-icon-trash", callback: this.onDeleteAction }
                    ]),
                });
                this.assign(view, this.zone.$menu);
            }
            view.toggle();
        },

        filterItems: function() {
            var model = this.model,
                items = this.collection.getAllItems(model.getCalendarItemType());
            if (model.getType() === 'custom') {
                items = this.filterCustomDataItem(items);
            }

            var goalStartDate = this.model.get("startDate");
            var goalType = this.model.get("type");

            //Second filter to display only the calendar entry with a date equal or after the goal creation date
            if (goalType !== 'waistline' && goalType !== 'weight')
                items = _.reject(items, function(el) { return el.get("date") < goalStartDate; });

            this.items.reset(_.first(items, 4));

            if (items.length) {
                this.zone.$noItems.hide();
            } else {
                this.zone.$noItems.show();
            }
        },

        filterCustomDataItem: function(items) {
            return _.filter(items, function(item) {
                return item.get('customData') === this.model.get('customData_id');
            }, this);
        },

        setNewCalendarItemUrl: function() {
            var url = this.url.root + 'calendar/{{date}}/{{itemType}}/';
            var context = this.getNewCalendarItemContext();

            if (this.model.getType() === "custom") {
                url = this.url.root + 'calendar/{{date}}/{{itemType}}?itemId={{itemId}}';
                context.itemId = this.model.get('customData_id');
            }

            this.options.newItemUrl = Mustache.render(url, context);
        },

        getNewCalendarItemContext: function() {
            return {
                date: moment().format('YYYY-MM-DD'),
                itemType: this.model.getCalendarItemType(),
                groupId: this.group.id,
                userId: this.profile.id,
            };
        },

        getItemId: function(itemType) {
            switch (itemType) {
                case 'weight': return MPersonalDataType.prototype.weightId;
                case 'waistline': return MPersonalDataType.prototype.waistlineId;
                default: return null;
            }
        },

        ////////////
        // actions //
        ////////////
        onActionClick: function(e, item, menu) {
            e.preventDefault();
        },

        onEditAction: function() {
            this.model.trigger("goal:edit", this.model);
        },

        onDeleteAction: function(e) {
            Bootbox.confirm({
                title: i18n.t('goal:Delete a goal'),
                message: i18n.t('messages:message-delete-goal'),
                callback: this.onDelete,
                context: this,
            });
        },

        isSupervisorMode: function() {
            var parts = Backbone.history.getFragment().split('/');
            if (parts[0] === 'supervisor') return true;
            return false;
        },

        ////////////
        // events //
        ////////////
        onDelete: function(result) {
            if (result) {
                this.model.destroy({ wait: true });
            }
        },

        onItemUpdate: function(model) {
            if (model.getType() === this.model.getCalendarItemType()) {
                var items = this.items,
                    models = items.first(items.get(model) ? 4 : 3);
                models.push(model);
                this.items.set(models);
            }
            //this.view.chart.render();
        },

        onCalendarItemUpdate: function(model, value) {
            if (value) this.view.items.onShowFeedback(model);
        },

        onCalendarItemDestroy: function() {
            this.model.fetch({
                success: this.render,
                context: this
            });
        },

        onCalendarDaysSync: function(collection) {
            this.filterItems();
        },

        onDisable: function() {
            this.stopListeningTo(CalendarEvents);
        },

        onClickAddGoalCalendar: function(e) {
            if (!this.isSupervisorMode() && !this.model.get('customData_memberEntry')) {
                e.preventDefault();
                ToastrService.error('messages:only-supervisor-log-data');
            }
        },

    });

    return VGoalListItem;
});

